import { useTabUrl } from '@common/hooks/useTabUrl';
import { useUrlState } from '@common/hooks/useUrlState';
import { Layout } from '@common/layouts';
import { NavigationTabsOption } from '@common/types/link';
import { QueryState } from '@common/types/queryState';
import { GlobalQuerySchema } from '@constants/queryScema';
import { Box } from '@radix-ui/themes';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ClipSearchView, CollectionSearchView } from '../components';

export const AdvancedSearchPage = () => {
    const { t } = useTranslation('advancedSearch');

    const { reset } = useUrlState<QueryState>(GlobalQuerySchema);

    const handleTabChange = useCallback(() => {
        reset({ except: ['search'] });
    }, [reset]);

    const searchOptions: NavigationTabsOption<'collection' | 'clip'>[] = [
        {
            label: t('table.modes.collection'),
            value: 'collection',
            queryKey: 'type',
        },
        { label: t('table.modes.clip'), value: 'clip', queryKey: 'type' },
    ];

    const { currentTab } = useTabUrl(
        searchOptions,
        'collection',
        handleTabChange,
        ['search'],
    );

    return (
        <Layout.Content direction={'row'} overflow={'hidden'}>
            <Box height={'100%'} p='4'>
                {currentTab === 'collection' && (
                    <CollectionSearchView
                        tabOptions={searchOptions}
                        key='collection'
                    />
                )}
                {currentTab === 'clip' && (
                    <ClipSearchView tabOptions={searchOptions} key='clip' />
                )}
            </Box>
        </Layout.Content>
    );
};
